import { useCallback, useMemo, useState } from "react";

export type RowSectionType = "pix" | "orders";
type OpenState = Record<string, RowSectionType | null>;

export function useRowSectionToggle() {
  const [openByRow, setOpenByRow] = useState<OpenState>({});

  const isOpen = useCallback(
    (rowId: string, type: RowSectionType) => openByRow[rowId] === type,
    [openByRow]
  );

  const select = useCallback((rowId: string, type: RowSectionType) => {
    setOpenByRow((prev) => ({
      ...prev,
      [rowId]: prev[rowId] === type ? null : type,
    }));
  }, []);

  const close = useCallback((rowId: string) => {
    setOpenByRow((prev) => ({ ...prev, [rowId]: null }));
  }, []);

  const api = useMemo(() => ({ isOpen, select, close }), [
    isOpen,
    select,
    close,
  ]);

  return api;
}
